<h2 mat-dialog-title i18n>Edit values</h2>

<mat-dialog-content class="dialog-content">
  <p class="dialog-subtitle" i18n>
    Add, remove, and edit dropdown values.
  </p>

  <div class="values-list">
    @for (item of values; track $index; let i = $index) {
      <div class="value-row">
        <mat-form-field appearance="outline" class="value-field">
          <mat-label i18n>Value</mat-label>
          <input matInput [(ngModel)]="item.value" />
        </mat-form-field>

        <mat-form-field appearance="outline" class="number-field">
          <mat-label i18n>Numeric value</mat-label>
          <input
            matInput
            type="number"
            [(ngModel)]="item.numericValue"
            [disabled]="data.numericValueDisabled"
          />
        </mat-form-field>

        <div class="row-actions">
          <button
            mat-icon-button
            type="button"
            (click)="moveUp(i)"
            [disabled]="i === 0"
            aria-label="Move up"
            i18n-aria-label
          >
            <mat-icon>arrow_upward</mat-icon>
          </button>

          <button
            mat-icon-button
            type="button"
            (click)="moveDown(i)"
            [disabled]="i === values.length - 1"
            aria-label="Move down"
            i18n-aria-label
          >
            <mat-icon>arrow_downward</mat-icon>
          </button>

          <button
            mat-icon-button
            type="button"
            color="warn"
            (click)="removeValue(i)"
            aria-label="Remove value"
            i18n-aria-label
          >
            <mat-icon>delete</mat-icon>
          </button>
        </div>
      </div>
    }
  </div>
  <div class="add-row">
    <mat-form-field
      appearance="outline"
      floatLabel="always"
      class="value-field"
      subscriptSizing="dynamic"
    >
      <mat-label i18n>New value</mat-label>
      <input matInput #newValue />
    </mat-form-field>

    <mat-form-field
      appearance="outline"
      floatLabel="always"
      class="number-field"
      subscriptSizing="dynamic"
    >
      <mat-label i18n>Numeric value</mat-label>
      <input
        matInput
        type="number"
        #newNumericValue
        [disabled]="data.numericValueDisabled"
      />
    </mat-form-field>

    <button
      mat-flat-button
      color="primary"
      type="button"
      (click)="addValue(newValue.value, newNumericValue.value); newValue.value = ''; newNumericValue.value = ''"
      i18n
    >
      Add
    </button>
  </div>

  @if (data.numericValueDisabled) {
    <div class="dialog-hint" >
      <span i18n>Numeric values are not supported for radio type. </span>
    </div>
  }
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button type="button" (click)="cancel()" i18n>Cancel</button>
  <button mat-flat-button color="primary" type="button" (click)="save()" i18n>
    Save
  </button>
</mat-dialog-actions>
